import { ITragger } from "../interfaces/ITrigger";
import api from "../services/trigger/api";

class TriggerAPI {
    acionar = async (acionamento: ITragger) => await api.get(`/acionamento/chaveVirtual/${acionamento.acionamentoId}/${acionamento.visitanteId}/${acionamento.latitude}/${acionamento.longitude}/${acionamento.visitanteId}/2`);
}

export default new TriggerAPI();